import {transform} from 'lodash';
import {encodeRequestBody} from './HttpUtil';
import {DefaultLanguage, LanguageForApi} from "@constants/Enums";
import moment from "moment-timezone";

export function transformKeysToLowerCase(data) {
    return transform(data, function (result, val, key) {
        result[key.toLowerCase()] = val;
    })
}

export function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export const Re8Characers = /(?!.*\s).{8,}$/;
export const ReLowerCase = /(?=(.*[a-z]){1,})/;
export const ReUpperCase = /^(?=.*?[A-Z])/;
export const ReNumber = /\d/;

export function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export function correctedFilter(filter) {
    let keys = Object.keys(filter).filter(item => filter[item]);
    let obj = {};
    keys.forEach(k => {
        obj[k] = filter[k];
    });
    return obj;
}

export function grtParamsQueryByFilter(filter, pagination) {
    let filterParams = encodeRequestBody({
        ...filter,
        Lang: LanguageForApi[(localStorage.getItem('lang') || DefaultLanguage)]
    });
    let paginationParams = pagination ? '&' + encodeRequestBody({
        Page: pagination.Page,
        Limit: pagination.Limit
    }) : '';
    return `?${filterParams}${paginationParams}`;
}

export const addNameProperty = (obj) => {
    obj.name = obj[(localStorage.getItem('lang') || DefaultLanguage)];
    return obj
}

export function correctedBy(list) {
    return list.map((item, i) => {
        return {
            id: item.id,
            orderId: i + 1
        }
    });
}

export function addIndexWithDragDrop(data) {
    if (data && data.length > 0) {
        data.sort((a, b) => a.orderId - b.orderId).forEach((item, index) => {
            item.index = index + 1;
        });
        return data;
    }
    return [];
}

function filterActions(type, key) {
    let t;
    if (type.search(key) != -1) {
        t = type.replace(key, '').toLowerCase();
    }
    return t;
}

export function isRequest(type) {
    return filterActions(type, 'REQUEST');
}

export function isAddOrEditData(type) {
    return filterActions(type, 'ADD') || filterActions(type, 'EDIT');
}

export function isSetData(type) {
    return filterActions(type, 'SET');
}

export function isSetDataAndCsvUpload(type) {
    return (filterActions(type, 'SET') && filterActions(type, 'CSV'));
}

export const getUrlValue = (str, keysOfDate = []) => {
    const urlParams = {}
    if (str) {
        const url = new URLSearchParams(str)
        for (const [key, value] of url) {
            if (key === "ip") {
                const ipRegExp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(value);
                if (!ipRegExp) continue;
            }
            if ( keysOfDate.indexOf(`${key}`) > -1) {
                urlParams[`${key}`] =  moment(value).utc().format()
            } else {
                urlParams[`${key}`] = value || ''
            }

        }
    }
    return urlParams;

}

export const getUrlString = (urlParams) => {
    let params = new URLSearchParams();

    Object.keys(urlParams).forEach(item => {
        if (typeof urlParams[item] !== 'object') {
            if (urlParams[item]) {
                params.set(item, urlParams[item])
            }
        } else {
            if (urlParams[item].start) {
                params.set(""+item+"From", urlParams[item].start)
            }
            if (urlParams[item].end) {
                params.set(""+item+"To", urlParams[item].end)
            }
        }
    });
    return {params}
}

export function getQuery(params) {
    let query = '';
    Object.keys(params).forEach(item => {

        if (typeof params[item] !== 'object') {
            if(params[item] !== "") {
                if (item === "statuses" || item === "types") {
                    const select =  params[item].split(",")
                    select.forEach(s => query += item + '=' + s + '&')
                } else {
                    query += item + '=' + encodeURIComponent(params[item])  + '&';
                }
            }
        } else {
            if (params[item].start) {
                query += item + 'From=' + (params[item].start || "") + '&';
            }
            if( params[item].end) {
                query += item + 'To=' + (params[item].end || "") + '&';
            }

        }
    })
    if (query) {
        query = query.slice(0, -1);
    }

    return query
}
